import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import * as Constants from "../../../constants/Constants";
import { GrubPopupErrorHook } from "../../../hooks/index";
import { forgotPassword } from "../services/authServices";

export const useForgotPassword = (props) => {
    //Hooks
    const { error } = GrubPopupErrorHook();

    //States
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [serverResponse, setServerResponse] = useState({});
    const [keyboardOpen, setKeyboardOpen] = useState(false);
    const emailRef = useRef(false);

    useEffect(() => {
        if (props.isOpen) {
            setIsFocused(true);
            setTimeout(() => {
                emailRef.current = true;
            }, 2000);
        }
        const onResize = () => {
            if (window.visualViewport.height < window.innerHeight) {
                setKeyboardOpen(true);
            } else {
                setKeyboardOpen(false);
            }
        };

        window.visualViewport.addEventListener("resize", onResize);
        return () =>
            window.visualViewport.removeEventListener("resize", onResize);
    }, [props.isOpen]);

    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .trim()
                .required(Constants.USER_EMAIL_REQUIRED)
                .matches(Constants.EMAIL_REGEX, Constants.USER_EMAIL_NOT_VALID)
                .max(
                    254,
                    Constants.USER_EMAIL_LESS_THEN_OR_EQUAL_255_CHARACTER
                ),
        }),
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (values) => {
            setLoading(true);
            const Values = {
                email: values.email.trim(),
                tenant: localStorage.getItem("tenant"),
            };
            try {
                forgotPassword(Values)
                    .then((response) => {
                        if (
                            undefined !== response.data.flag &&
                            null !== response.data.flag &&
                            response.data.flag == true
                        ) {
                            formik.resetForm();
                            setServerResponse({
                                error: false,
                                message: Constants.USER_FORGOT_PASSWORD_SUCCESS,
                            });
                            setTimeout(() => {
                                setServerResponse({});
                            }, 5000);
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        let actionData = err;
                        let popupError = error({ actionData });
                        if (popupError.error) {
                            setServerResponse(popupError);
                            setTimeout(() => {
                                setServerResponse({});
                            }, 5000);
                        }
                        setLoading(false);
                    });
            } catch (error) {
                let actionData = error;
                let popupError = error({ actionData });
                if (popupError.error) {
                    setServerResponse(popupError);
                    setTimeout(() => {
                        setServerResponse({});
                    }, 5000);
                }
                setLoading(false);
            }
        },
    });

    const handleKeyDown = (event) => {
        if (
            event.key === "Enter" &&
            !(formik.values.email.length <= 0 || formik.errors.email)
        ) {
            formik.handleSubmit();
        }
    };
    return {
        handleKeyDown,
        formik,
        isFocused,
        emailRef,
        loading,
        serverResponse,
        keyboardOpen,
    };
};
